<template>
  <div id="eventlist">
    <h1
      v-if="
        eventsFeatureCollection.features === undefined ||
          eventsFeatureCollection.features.length == 0
      "
    >
      Er zijn geen evenementen gepland in de periode van {{ startDate }} tot en
      met {{ endDate }}.
    </h1>

    <div v-else id="scrolltable">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th class="mw-100"><div>Naam</div></th>
            <th><div>Locatie</div></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(event, index) in eventsFeatureCollection.features"
            :key="event.id"
            v-bind:class="{ 'is-selected': index == selectedEventIndex }"
            v-on:click="onSelectedEvent(index)"
          >
            <td>
              {{ event.properties.name }}
              <p
                v-if="event.properties.startdatum == event.properties.einddatum"
                class="dates"
              >
                Op {{ event.properties.startdatum }}
              </p>
              <p v-else class="dates">
                Van {{ event.properties.startdatum }} tot
                {{ event.properties.einddatum }}
              </p>
            </td>
            <td>{{ event.properties.locatie }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "EventList",
  computed: {
    ...mapGetters({
      selectedEventIndex: "dataEventSelectedEventIndex",
      eventsFeatureCollection: "dataEventCollectionFeature",
      startDate: "dataFilterStartDate",
      endDate: "dataFilterEndDate"
    })
  },
  methods: {
    onSelectedEvent(index) {
      this.$store.commit("setDataEventsSelectedIndex", index);
    }
  }
};
</script>

<style scoped>
.eventlist {
  height: 500px;
  overflow-y: hidden;
}

#scrolltable {
  margin-top: 20px;
  height: 417px;
  overflow: auto;
}
#scrolltable th div {
  position: absolute;
  margin-top: -20px;
  padding-left: 12px;
  padding-bottom: 10px;
  margin-left: -12px;
}
#scrolltable th:first-child div {
  width: 382px;
  background-color: white;
  border-bottom: #cbcbcb 1px solid;
}

.date {
  width: 106px;
}

.dates {
  font-size: 0.7em;
  font-style: italic;
}
.mw-100 {
  min-width: 100px;
}
</style>
